export function checkServiceWorkerUpdate() {
    //  console.log('serviceworkder.111..',navigator);
  if ('serviceWorker' in navigator) {
    // console.log('serviceworkder...',navigator);
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => {
        console.log('Checking for service worker updates...');
        registration.update();
        // registration.update().then(() => {
        //   if (registration.waiting) {
        //     console.log('New service worker is waiting to activate.');
        //     // Show toast, popup, or reload prompt here if needed
        //   }
        // });
      });
    }).catch(err => {
      console.error('Service worker update check failed:', err);
    });
  }
}